<template>
<div class="chapter">
<div class="inner_page">
<p class="chapname">Acknowledgements</p>
<p class="noindentt">I wish to acknowledge the mentorship and friendship over many years of the following people, whose advice and support helped shape my thinking and inspired this project: General Marty Dempsey, General Mike Scaparrotti, General Mick Nicholson, Lieutenant General H. R. McMaster, Lieutenant General Rick Waddell, Lieutenant General Mike Fenzel, Major General Skip Davis, Major General Matt McFarlane, Major General Ken Hara, Brigadier General Mitchell Zais, Colonel Ladd Pattillo, Colonel Bob Frusha, Colonel Bob Hoidahl, Lieutenant Colonel Robert Quinnett, Sergeant Major of the Army Jack Tilley, Command Sergeant Major Abdo Zacheus, Command Sergeant Major Joe Picanco and Master Sergeant Nick Keane. I extend grateful appreciation to the editors of <i>Army</i> magazine who have offered kind permission to reprint my work in this forum, and to the exceptional staffs at Casemate Publishers and the Association of the US Army who so generously contributed to making <i>The High Ground</i> possible. Lastly, I gratefully acknowledge the service and sacrifice of the soldiers of the US Army, past and present, to whom I owe so much. I was honored to serve in their ranks.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Acknowledgements.vue?4850e9ca